import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { BasketService } from 'src/app/checkout-page/services/basket.service';
import { LANGUAGE } from 'src/core-lib/misselaineous/boot.tokens';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { PipeModule } from 'src/core-lib/pipes/pipe.module';
import { VarModule } from 'src/core-lib/var/var.module';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { GridModule } from 'src/layout/grid/grid.module';
import { ImageUtil } from 'src/layout/media/image.util';
import { MediaModule } from 'src/layout/media/media.module';
import { MarketSegment } from 'src/utils/market-segment.util';
import { ContentCacheUtils } from 'src/utils/storage.util';
import { HeaderBasketButtonComponent } from './components/header-basket-button/header-basket-button.component';
import { HeaderMenuComponent } from './components/header-menu/header-menu.component';
import { HeaderSearchComponent } from './components/header-search/header-search.component';
import { RecursiveLinkComponent } from './components/recursive-link/recursive-link.component';
import { MainConfiguration, MenuConfiguration } from '../../models/main-configuration.model';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [],
    standalone: true,
    imports: [
        TagManagerModule,
        CommonModule,
        MediaModule,
        NavigationModule,
        TranslateModule,
        ReactiveFormsModule,
        PipeModule,
        GridModule,
        VarModule,
        HeaderSearchComponent,
        HeaderBasketButtonComponent,
        HeaderMenuComponent,
        RecursiveLinkComponent,
    ]
})
export class HeaderComponent {
    basketQuantity$: Observable<number>;

    menu: Partial<MenuConfiguration>;
    system: Partial<MainConfiguration>;

    checkout: { basketPageLink: string };
    logoUrl: URL;
    mobileLogoUrl: URL;
    marketSegments: Array<MarketSegment.Type>;
    selectedMarketSegment: MarketSegment.Type;
    selectedMarketSegmentDiff: string;
    constructor(
        private basketService: BasketService,
        @Inject(LANGUAGE)
        public catalog: string,
        private _detector: ChangeDetectorRef,
    ) {
        this.basketQuantity$ = this.basketService.basket$.pipe(
            map(basket => basket?.quantity > 0 ? basket.quantity : null),
            shareReplay(1),
        );
        this.system = ContentCacheUtils.system<MainConfiguration>();
        this.menu = ContentCacheUtils.menu<MenuConfiguration>();

        this.logoUrl = ImageUtil.getURL(this.system?.theme?.logo, { height: 68, width: 155, });
        this.mobileLogoUrl = ImageUtil.getURL(this.system?.theme?.logoMobile ?? this.system?.theme?.logo, { height: 50, width: 120, });

        this.checkout = ContentCacheUtils.checkout<{ basketPageLink: string }>();
        this.marketSegments = MarketSegment.getSegments();
        var selectedMarket = MarketSegment.getSelected()
        this.selectedMarketSegment = selectedMarket;
        this.selectedMarketSegmentDiff = MarketSegment.getSegments().filter(__ => __ == selectedMarket).find(() => true) ?? 'B2B';

        this._detector.markForCheck();

    }

    toggleMarketSegment() {

        MarketSegment.toggle();
    }

}
